export default function HistorytIcon(props) {
	return (
		<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.4444 0V1.8H15.1111C15.6018 1.8 16 2.2032 16 2.7V17.1C16 17.5968 15.6018 18 15.1111 18H0.888889C0.398222 18 0 17.5968 0 17.1V2.7C0 2.2032 0.398222 1.8 0.888889 1.8H3.55556V0H12.4444ZM8.88889 8.1H7.11111V9.9H5.33333V11.7H7.11022L7.11111 13.5H8.88889L8.888 11.7H10.6667V9.9H8.88889V8.1ZM10.6667 1.8H5.33333V3.6H10.6667V1.8Z"
				fill="currentColor"
			/>
		</svg>
	);
}
